import styled, { css } from 'styled-components';

import { ButtonVariant } from '#/service/constants';

import Button, { ButtonProps } from './Button/Button';
import { focusShadow } from './common';

interface LinkButtonProps extends ButtonProps {
  /**
   * Focus/active color mode.
   * When `true` - use paragraph color for hover, when `false` - use normal link color for hover
   * @default false
   * */
  $highlighted?: boolean;

  /** How the link button should look like @default 'default' */
  $variant?: 'default' | 'title';
}

const StyledButton = styled(Button)<LinkButtonProps>`
  padding: 0;
  outline: none;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};

  ${({ $variant = 'default' }) =>
    $variant === 'title' &&
    css`
      font: var(--fontStyleTitle);
      color: var(--pageHeadingForeground);
    `};

  &,
  &:hover,
  &:active,
  &:focus {
    color: ${({ $highlighted = false }) =>
      $highlighted
        ? `var(--pageParagraphForeground)`
        : `var(--pageLinkForeground)`};
    background: none;
    border: none;
  }

  &:hover:enabled,
  &:active:enabled {
    opacity: 0.7;
  }

  &.focus-visible {
    ${focusShadow}
  }
`;

export const LinkButton = (props: LinkButtonProps) => (
  <StyledButton variant={props.variant ?? ButtonVariant.Ghost} {...props} />
);

LinkButton.displayName = 'LinkButton';
